export default __webpack_public_path__ + "static/media/openhat.33ed152b.ogg";